import React from 'react'
import { Logo } from './../../components'
import { AuthStyle } from './../../styles'

export default ({children}) => (
  <div className={ `${AuthStyle}`}>
    <div className="auth--middle">
      <Logo nClass="logo" width="359" height="28" />
      <h2 className="">Brand center</h2>
      <div className="auth--container">
        {children}
      </div>
    </div>
  </div>
)


// WEBPACK FOOTER //
// ./src/scenes/Layout/AuthLayout.js